/**
 * Standard reducing-balance EMI formula.
 * @param {number} principal Loan amount
 * @param {number} annualRate Annual interest rate (e.g. 10.5)
 * @param {number} months Tenure in months
 */
export const calculateEmi = (principal, annualRate, months) => {
  const p = Number(principal) || 0;
  const n = Number(months) || 0;
  const r = (Number(annualRate) || 0) / 12 / 100;

  if (p <= 0 || n <= 0) {
    return { emi: 0, totalInterest: 0, totalPayable: 0 };
  }

  if (r === 0) {
    const emi = p / n;
    return { emi, totalInterest: 0, totalPayable: p };
  }

  const factor = (1 + r) ** n;
  const emi = (p * r * factor) / (factor - 1);
  const totalPayable = emi * n;
  const totalInterest = totalPayable - p;

  return { emi, totalInterest, totalPayable };
};

export const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
